import React from "react";

type Props = {};

const VacancyContractDeposit = (props: Props) => {
  return (
    <div>
      <div className="value-html">
        <p style={{ textAlign: "center" }}>
          <strong>
            Vereinbarung über Sicherheitsleistungen durch Geldleistung in
            Mietverträgen
          </strong>
        </p>
        <p>&nbsp;</p>
        <p style={{ textAlign: "justify" }}>
          zu dem Mietvertrag zum{" "}
          <span className="mention-variable" data-variable-id="moveInDate">
            $MoveIn-Date
          </span>{" "}
          zu der Wohnung im{" "}
          <span
            className="mention-variable"
            data-variable-id="rentalUnitFloorDisplayName"
          >
            $Rental-Unit-Floor-DisplayName
          </span>{" "}
          in
          <span className="mention-variable" data-variable-id="objectAddress">
            $Object-Address
          </span>
          ,{" "}
          <span className="mention-variable" data-variable-id="objectZip">
            $Object-Zip
          </span>{" "}
          <span className="mention-variable" data-variable-id="objectCity">
            $Object-City
          </span>
          .<br />
        </p>
        <p style={{ textAlign: "justify" }}>
          Für die Erfüllung ihrer Pflichten zahlen die Mieter dem Vermieter als
          Sicherheit
        </p>
        <p>&nbsp;</p>
        <p style={{ textAlign: "center" }}>
          <span>
            <strong>
              zum{" "}
              <span>
                <span
                  className="mention-variable"
                  data-variable-id="depositDate"
                >
                  $Deposit-Date
                </span>
              </span>
              <span>
              &nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;
                <span
                  className="mention-variable"
                  data-variable-id="depositSum"
                >
                  $Deposit-Sum
                </span>
              </span>
            </strong>
          </span>
        </p>
        <p style={{ textAlign: "center" }}>&nbsp;</p>
        <p>Die Sicherheitsleistung wird auf das Konto eingezahlt:</p>
        <p>&nbsp;</p>
        <p style={{ textAlign: "justify" }}>
          <span>
            <strong>
              Gesellschaft:{" "}
              <span
                className="mention-variable"
                data-variable-id="entityDisplayName"
              >
                $EntityDisplayName
              </span>
            </strong>
          </span>
          <br />
          <span>
            <strong>
              IBAN:&nbsp;
              <span className="mention-variable" data-variable-id="iban">
                $IBAN
              </span>
            </strong>
          </span>
          <br />
          <span>
            <strong>
              BIC:&nbsp;
              <span className="mention-variable" data-variable-id="bic">
                $BIC
              </span>
            </strong>
          </span>
          <br />
          <span>
            <strong>
              Kreditinstitut:&nbsp;
              <span className="mention-variable" data-variable-id="bankName">
                $Bankname
              </span>
            </strong>
          </span>
          <br />
          <span>
            <strong>
              Verwendungszweck:&nbsp;
              <span
                className="mention-variable"
                data-variable-id="bankUsageReferenceDeposit"
              >
                $Bank-Usage-Reference
              </span>
            </strong>
          </span>
        </p>
        <p>&nbsp;</p>
        <p>Die Sicherheitsleistung ist separat von der Miete zu überweisen.</p>
        <p>&nbsp;</p>
        <p>
          Die Sicherheitsleitung und die aufgelaufenen Zinsen sind nach
          Beendigung des Mietverhältnisses und Ablauf einer angemessenen
          Überlegungs- und Prüfungsfrist abzurechnen und, soweit ein Guthaben
          besteht, auszuzahlen. Der Auszahlungsanspruch der Mieter kann weder
          abgetreten noch verpfändet werden.
        </p>
        <br></br>
      </div>
    </div>
  );
};

export default VacancyContractDeposit;
